import { ReportType } from 'app/dataTypes/reports'

export const apiStringFromReportType = (reportType: ReportType): string => {
  if (reportType === ReportType.Corrections) return 'corrections'
  if (reportType === ReportType.OrdersByClasses) return 'goverment_cafeteria_orders_by_classes'
  if (reportType === ReportType.FinancesSummary) return 'finances_summary'
  if (reportType === ReportType.FinancesSummaryReplenishment) return 'finances_payments'
  if (reportType === ReportType.FinancesSummaryWriteOff) return 'finances_write_offs'
  // TODO все отчеты
  const exhaustiveCheck: never = reportType
  return exhaustiveCheck
}
